import React from 'react';
import moment from "moment";
import neoLogo from "../../../../assets/images/Neo_Logo_A.svg";

/**
 * PrintableWorkout
 * Componente oculto na tela que renderiza o treino selecionado
 * para impressão no padrão A4.
 */
class PrintableWorkout extends React.Component {
    calculateTotalDistance(blocks) {
        let total = 0;
        blocks?.forEach(block => {
            block.sets?.forEach(set => {
                total += (Number(set.reps) || 0) * (Number(set.distance) || 0);
            });
        });
        return total;
    }

    render() {
        const { workout, tenantName, tenantLogo } = this.props;

        if (!workout) return null;

        const date = workout?.date
            ? moment(workout.date).format("DD/MM/YYYY")
            : "--";
            
        const totalDistance = this.calculateTotalDistance(workout.blocks);

        return (
            <div style={{ padding: "30px 40px", fontFamily: "'Inter', 'Helvetica Neue', Helvetica, Arial, sans-serif", color: "#333", backgroundColor: "#fff" }}>

                {/* ═══ CABEÇALHO ═══ */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", borderBottom: "2px solid #eee", paddingBottom: "20px", marginBottom: "24px" }}>
                    {/* ESQUERDA: Logo */}
                    <div style={{ flex: "0 0 auto", minWidth: "120px" }}>
                        {tenantLogo && (
                            <img src={tenantLogo} alt="Logo" style={{ maxHeight: "70px", maxWidth: "160px", objectFit: "contain" }} />
                        )}
                    </div>

                    {/* DIREITA: Nome + Dados do Treino */}
                    <div style={{ textAlign: "right", flex: "1 1 auto", paddingLeft: "15px" }}>
                        <h2 style={{ margin: "0 0 6px 0", fontSize: "14px", fontWeight: "700", color: "#555", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                            {tenantName || "Equipe / Professor"}
                        </h2>
                        <h3 style={{ margin: "0 0 4px 0", fontSize: "18px", fontWeight: "700", color: "#111" }}>
                            {workout?.title || "Treino"}
                        </h3>
                        <p style={{ margin: "2px 0", fontSize: "13px", color: "#555" }}>
                            <strong>Data:</strong> {date}
                        </p>
                        <p style={{ margin: "2px 0", fontSize: "13px", color: "#555" }}>
                            <strong>Volume Total:</strong> {totalDistance}m
                        </p>
                    </div>
                </div>

                {/* ═══ DESCRIÇÃO DO TREINO ═══ */}
                {workout?.description && (
                    <div style={{ marginBottom: "24px", padding: "12px 16px", backgroundColor: "#f8f9fa", borderRadius: "6px", border: "1px solid #e9ecef" }}>
                        <h4 style={{ margin: "0 0 8px 0", fontSize: "14px", fontWeight: "600", color: "#333" }}>Objetivos / Observações</h4>
                        <p style={{ margin: 0, fontSize: "13px", color: "#555", whiteSpace: "pre-wrap" }}>
                            {workout.description}
                        </p>
                    </div>
                )}

                {/* ═══ BLOCOS DE TREINO ═══ */}
                {(workout.blocks || []).map((block, bIndex) => (
                    <div key={bIndex} style={{ marginBottom: "24px" }}>
                        <h4 style={{ 
                            margin: "0 0 12px 0", 
                            fontSize: "15px", 
                            fontWeight: "700", 
                            color: "#111",
                            paddingBottom: "6px",
                            borderBottom: "1px solid #ddd"
                        }}>
                            {block.name || `Bloco ${bIndex + 1}`}
                        </h4>
                        
                        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
                            <thead>
                                <tr style={{ backgroundColor: "#212529", color: "#fff", textAlign: "left" }}>
                                    <th style={{ padding: "8px 12px", fontWeight: "600", width: "12%", textAlign: "center" }}>Séries</th>
                                    <th style={{ padding: "8px 12px", fontWeight: "600", width: "12%", textAlign: "center" }}>Metragem</th>
                                    <th style={{ padding: "8px 12px", fontWeight: "600", width: "18%" }}>Estilo</th>
                                    <th style={{ padding: "8px 12px", fontWeight: "600", width: "15%" }}>Intensidade</th>
                                    <th style={{ padding: "8px 12px", fontWeight: "600", width: "15%" }}>Intervalo</th>
                                    <th style={{ padding: "8px 12px", fontWeight: "600", width: "28%" }}>Materiais / Obs</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(block.sets || []).map((set, sIndex) => (
                                    <tr 
                                        key={sIndex}
                                        style={{
                                            borderBottom: "1px solid #dee2e6",
                                            backgroundColor: sIndex % 2 === 0 ? "#fff" : "#f8f9fa"
                                        }}
                                    >
                                        <td style={{ padding: "8px 12px", textAlign: "center", fontWeight: "600", color: "#333" }}>
                                            {set.reps || "-"}x
                                        </td>
                                        <td style={{ padding: "8px 12px", textAlign: "center", fontWeight: "700", color: "#2ecc71" }}>
                                            {set.distance || "-"}m
                                        </td>
                                        <td style={{ padding: "8px 12px", color: "#111", fontWeight: "500" }}>
                                            {set.style || "-"}
                                        </td>
                                        <td style={{ padding: "8px 12px", color: "#555" }}>
                                            {set.intensity || "-"}
                                        </td>
                                        <td style={{ padding: "8px 12px", color: "#555" }}>
                                            {set.interval || "-"}
                                        </td>
                                        <td style={{ padding: "8px 12px", color: "#555", fontSize: "12px" }}>
                                            {set.description || "-"}
                                        </td>
                                    </tr>
                                ))}
                                {(!block.sets || block.sets.length === 0) && (
                                    <tr>
                                        <td colSpan="6" style={{ padding: "8px 12px", textAlign: "center", color: "#888", fontStyle: "italic" }}>
                                            Nenhum exercício adicionado a este bloco.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                ))}

                {/* ═══ RODAPÉ ═══ */}
                <div style={{ marginTop: "40px", paddingTop: "20px", borderTop: "2px solid #eee" }}>
                    <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-end" }}>
                        <div style={{ textAlign: "right" }}>
                            <p style={{ margin: "0 0 5px 0", fontSize: "11px", fontStyle: "italic", color: "#999" }}>
                                Gerado em {moment().format("DD/MM/YYYY [às] HH:mm")}.
                            </p>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "6px", marginTop: "8px" }}>
                                <span style={{ fontSize: "11px", fontWeight: "700", color: "#aaa", letterSpacing: "1px" }}>POWERED BY</span>
                                <img src={neoLogo} alt="NeoApp" style={{ height: "14px", filter: "grayscale(100%) opacity(0.6)" }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PrintableWorkout;
